import { LabelFormattingInfo } from '@ardoq/data-model';
import {
  getComponentLabelFormattingFilterAttributes,
  getReferenceLabelFormattingFilterAttributes,
} from './formattingRulesToFormattingAttributes';
import {
  ComponentLabelFormattingAttributes,
  ReferenceLabelFormattingAttributes,
} from '@ardoq/api-types';

export const fieldNameToFilterAttributes =
  ({ typeName, type, showFieldName }: LabelFormattingInfo) =>
  (fieldName: string) =>
    type === 'component'
      ? ({
          ...getComponentLabelFormattingFilterAttributes(fieldName, false),
          showFieldName: Boolean(showFieldName),
          ...(typeName && { affectsTypeName: typeName }),
        } satisfies ComponentLabelFormattingAttributes)
      : ({
          ...getReferenceLabelFormattingFilterAttributes(fieldName, false),
          showFieldName: Boolean(showFieldName),
          ...(typeName && { affectsTypeName: typeName }),
        } satisfies ReferenceLabelFormattingAttributes);

export const labelFormattingToFilterAttributes = (
  formatting: LabelFormattingInfo
) => formatting.fields.map(fieldNameToFilterAttributes(formatting));
